import "../i18n.mjs";
import { useCallback as e, useMemo as t } from "react";
import { useTranslation as n } from "react-i18next";
import { isHotelType as r } from "@maat/api-main/types";
//#region src/hooks/useInventoryVocabulary.ts
var i = /* @__PURE__ */ "unit.units.listing.listings.room.rooms.unitCount.listingCount.roomCount.addUnit.addListing.addRooms.editUnit.deleteUnit.deleteListing.unitActions.listingActions.unitAdded.listingAdded.unitSaved.unitDeleted.listingDeleted.deleteUnitTitle.deleteUnitBody.deleteListingTitle.deleteListingBody.noListingsTitle.noListingsBody.emptyTitle.emptyBody.tabUnits.pickListing.addUnitTitle.addUnitSubmit.editUnitTitle.addListingTitle.addListingSubmit.unitNameLabel.unitNamePlaceholder.listingTitleLabel.listingTitleRequired".split("."), a = (e, t) => `inventoryVocab.${e}.${t}`, o = (e) => r(e ?? void 0) ? "hotel" : "home", s = (r) => {
	let { t: i } = n("properties"), s = o(r), c = e((e, t) => i(a(s, e), t ?? {}), [i, s]);
	return t(() => ({
		kind: s,
		vocab: c
	}), [s, c]);
};
//#endregion
export { i as INVENTORY_VOCAB_KEYS, o as inventoryKindOf, a as inventoryVocabKey, s as useInventoryVocabulary };
